export default __webpack_public_path__ + "media/flags/kg-d056ead3.svg";